/**
 * Resolve the outlet the customer is ordering from (pickup origin for delivery).
 * Prefers route outlet_id, then Vuex selectedOutlet { value: id, text: name }.
 */
export function resolveOrderOutlet(
  franchise,
  selectedOutlet,
  outletIdFromRoute
) {
  const outlets = franchise?.outlets;
  if (!outlets || !outlets.length) return null;

  if (outletIdFromRoute != null && outletIdFromRoute !== "") {
    const fromRoute = outlets.find(
      (d) => String(d.id) === String(outletIdFromRoute)
    );
    if (fromRoute) return fromRoute;
  }

  if (selectedOutlet && typeof selectedOutlet === "object") {
    if (selectedOutlet.value != null && selectedOutlet.value !== "") {
      const fromId = outlets.find(
        (d) => String(d.id) === String(selectedOutlet.value)
      );
      if (fromId) return fromId;
    }
    if (selectedOutlet.text) {
      const fromName = outlets.find((d) => d.name === selectedOutlet.text);
      if (fromName) return fromName;
    }
  }

  if (typeof selectedOutlet === "string") {
    const fromName = outlets.find((d) => d.name === selectedOutlet);
    if (fromName) return fromName;
  }

  return outlets.length === 1 ? outlets[0] : null;
}

export function outletPickupAddress(outlet, franchise) {
  const src = outlet || franchise;
  return {
    address: src.address,
    address2: src.address2,
    postcode: src.postcode,
    // Saved in Cloud; used instead of geocoding the outlet when present
    city: src.city,
    state: src.state,
    pinpoint: src.pinpoint,
  };
}
